<template>
  <label class="sm-dropdown-preformat">
    <span 
      v-if="showLabel"
      class="sm-small"
      :class="{
        'sm-error': error
      }"
    >State</span>
    <dropdown-block
      v-model="selectedState"
      class="sm-dropdown scroll-y"
      :class="{
        'error': error
      }"
      :options="stateList"
      :ref="'elem'"
      :searchable="isSearchable"
      :close-on-select="true"
      :clear-on-select="true"
      :preselect-first="true"
      :placeholder="'Select state'"
      :custom-label="setCustomLabel"
      track-by="name"
      @input="handleSelect"
      @open="dropdownActive = true"
      @close="dropdownActive = false"
      :disabled="disabled"
    >
      <template slot="placeholder">
        <span>Select state</span>
        <include-svg :name="'icon-arrow-b'" />
      </template>
      <template slot="singleLabel" slot-scope="props">
        <span>{{ props.option.name }}</span>
        <include-svg :name="'icon-arrow-b'" />
      </template>
      <template slot="option" slot-scope="props" :value="props.option.id">
        <span>{{props.option.name}}</span>
      </template>
    </dropdown-block>
    <span 
      v-if="error"
      class="sm-tiny sm-error"
    >{{error}}</span>
  </label>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DropdownKeyEvents from '@/mixins/DropdownKeyEvents';

export default {
  name: 'state-dropdown',
  components: {
    'dropdown-block': Multiselect,
  },
  props: {
    stateList: {
      type: Array,
      default: () => []
    },
    startVal: {
      type: Object,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    isSearchable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {}
  },
  data() {
    return {
      selectedState: {
        code: '',
        id: null,
        name: ''
      }
    };
  },
  created() {
    if (this.startVal)
      this.selectedState = this.startVal;
  },
  mixins: [DropdownKeyEvents],
  methods: {
    handleSelect(e) {
      this.$emit('input', this.selectedState);
      this.$refs.elem.isOpen = false;
    },
    setCustomLabel(item) {
      return (`${item.name} ${item.code}`).toLowerCase();
    }
  },
  watch: {
    startVal(val) {
      if (val != this.selectedState)
        this.selectedState = val;
    }
  }
}
</script>